"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var vue_property_decorator_1 = require("vue-property-decorator");
var vue2_leaflet_1 = require("vue2-leaflet");
var parameters_1 = __importDefault(require("@/config/parameters"));
var leaflet_1 = require("leaflet");
var MapPointOfInterest = /** @class */ (function (_super) {
    __extends(MapPointOfInterest, _super);
    function MapPointOfInterest() {
        var _this = _super.call(this) || this;
        _this.center = [-34, 151];
        _this.zoom = 16;
        _this.initialMarker = null;
        _this.tileServerUrl = parameters_1.default.mapConfiguration.tileServerUrl;
        _this.attribution = parameters_1.default.mapConfiguration.attribution;
        _this.heightPx = 300;
        _this.icon = new leaflet_1.Icon({
            iconUrl: require('@/assets/images/Markers/SimpleMarker.png'),
            iconSize: [45, 45]
        });
        _this.endLocationMarker = null;
        _this.polyline = [];
        return _this;
    }
    MapPointOfInterest.prototype.mounted = function () {
        var _this = this;
        this.center = [this.pointOfInterest.gps_latitude, this.pointOfInterest.gps_longitude];
        this.initialMarker = [this.pointOfInterest.gps_latitude, this.pointOfInterest.gps_longitude];
        if (this.pointOfInterest.end_location_gps_latitude !== null && this.pointOfInterest.end_location_gps_longitude !== null) {
            this.endLocationMarker = [this.pointOfInterest.end_location_gps_latitude, this.pointOfInterest.end_location_gps_longitude];
            this.polyline = [this.initialMarker, this.endLocationMarker];
        }
        setTimeout(function () {
            _this.$refs.MapViewer.mapObject.invalidateSize();
        }, 1000);
    };
    __decorate([
        vue_property_decorator_1.Prop({ required: true })
    ], MapPointOfInterest.prototype, "pointOfInterest", void 0);
    MapPointOfInterest = __decorate([
        vue_property_decorator_1.Component({
            name: 'MapPointOfInterest',
            components: {
                LMap: vue2_leaflet_1.LMap,
                LMarker: vue2_leaflet_1.LMarker,
                LTileLayer: vue2_leaflet_1.LTileLayer,
                LTooltip: vue2_leaflet_1.LTooltip,
                LPolyline: vue2_leaflet_1.LPolyline
            }
        })
    ], MapPointOfInterest);
    return MapPointOfInterest;
}(vue_1.default));
exports.default = MapPointOfInterest;
